import React, { useState,useRef,useMemo } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { BlobProvider, Page, View, Document} from '@react-pdf/renderer';
import ItemTagsBarCode from "app/views/Pdf/ItemTagsBarCode"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode} from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

//Ici on crée un array avec tous les index possible avec lesquels une ligne de code barre peut commencer, car sur chaque lignes, on retourne 4 codes barres
//L'array se termine à lindex 48 car sur un datatable on ne retourne au maximum 50 lignes par appels
const indexAffiche = [0,4,8,12,16,20,24,28,32,36,40,44,48]

const IconBtn = (props) =>{
    const t =useTranslate()

    return(
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip>
                    {t('generateABarCodePdf')}
                </Tooltip>
            }
        >
            <div onClick={()=>props.handleClick()}>
                <FontAwesomeIcon className="text-dark" icon={faBarcode}/>
            </div>
        </OverlayTrigger>  
    )    
}

const GenerateBarCodeBtnA4 = (props) =>{
    const t = useTranslate();
    const [itemsWithBarCode,setItemsWithBarCode]=useState(false) 
    const btnPdf = useRef(null);

    const handleClick = () => {
        let arr = []

        props.articles.map(value=>{
            if(value.reference!=null && value.reference!='') arr.push(value)
        })

        setItemsWithBarCode(arr)

        setTimeout(() => {
            //on génère le pdf
            if(btnPdf) btnPdf.current.click()
        }, 1000);
    };

    // Memoized to keep a stable `document` reference across renders that don't actually change
    // itemsWithBarCode: BlobProvider regenerates and revokes its blob URL (URL.revokeObjectURL)
    // every time the `document` reference changes (@react-pdf/renderer usePDF, effect on [doc]), and
    // also revokes it on unmount. `itemsWithBarCode` used to be reset to `false` ~1500ms after each
    // click specifically to unmount BlobProvider and stop it from re-rendering the barcode PDF on
    // every unrelated re-render of this component (the same missing-memoization bug fixed here) —
    // that reset is now redundant (this memo already prevents those re-renders) and was dropped, since
    // keeping it would revoke the blob URL already opened in the hidden link's new tab, breaking its
    // download icon in Chrome's PDF viewer.
    const barCodeDocument = useMemo(()=>{
        if(!itemsWithBarCode) return false
        return (
            <Document>
                <Page size="A4">
                        {itemsWithBarCode.length!=0 && itemsWithBarCode.map((value,ind)=>{
                            if(indexAffiche.includes(ind)){
                                return(
                                    <View key={value.id} style={{display:'flex', flexDirection:'row', justifyContent:'center', marginBottom: (ind==32) ? 100 : '' }}>
                                        <ItemTagsBarCode articleBarCode={value.reference} articleName={(value.name.length>30) ? value.name.substring(0,27)+'...' : value.name} articlePrice={value.price+' '+props.devise} />

                                        {(itemsWithBarCode[ind+1]) && <ItemTagsBarCode articleBarCode={itemsWithBarCode[ind+1].reference} articleName={(itemsWithBarCode[ind+1].name.length>30) ? itemsWithBarCode[ind+1].name.substring(0,27)+'...' : itemsWithBarCode[ind+1].name} articlePrice={itemsWithBarCode[ind+1].price+' '+props.devise} />}

                                        {(itemsWithBarCode[ind+2]) && <ItemTagsBarCode articleBarCode={itemsWithBarCode[ind+2].reference} articleName={(itemsWithBarCode[ind+2].name.length>30) ? itemsWithBarCode[ind+2].name.substring(0,27)+'...' : itemsWithBarCode[ind+2].name} articlePrice={itemsWithBarCode[ind+2].price+' '+props.devise} />}

                                        {(itemsWithBarCode[ind+3]) && <ItemTagsBarCode articleBarCode={itemsWithBarCode[ind+3].reference} articleName={(itemsWithBarCode[ind+3].name.length>30) ? itemsWithBarCode[ind+3].name.substring(0,27)+'...' : itemsWithBarCode[ind+3].name} articlePrice={itemsWithBarCode[ind+3].price+' '+props.devise} />}
                                    </View>
                                )
                            }
                        })}
                </Page>
            </Document>
        )
    },[itemsWithBarCode,props.devise])

    return (
        <>
            {props.icon == 'false' ?
                <button className='btn btn-sm btn-success' onClick={()=>handleClick()} >{t('generateMasseBarCodePdf')}</button>
            :
                <IconBtn handleClick={handleClick}/>
            }
            {itemsWithBarCode ?
                <BlobProvider document={barCodeDocument}>
                    {({ url }) => (
                        <a ref={btnPdf} className="d-none" href={url} target="_blank">Print</a>
                    )}
                </BlobProvider>
            :
                false
            }
        </>
    )
};

export default GenerateBarCodeBtnA4;